export const PLAY_PACKAGE = 'gg.teamplay.twa';

/**
 * Каждая поверхность, откуда мы зовём ставить приложение, помечается своим `medium`.
 *
 * Google Play отдаёт содержимое `referrer` через Install Referrer API, а отчёт
 * «Привлечение пользователей» в Play Console разбирает из него стандартные `utm_*`.
 * Без метки все установки сваливаются в «органика / неизвестно», и понять, что дало
 * прирост — полоска в ленте, лендинг или письмо, — нельзя уже никогда: задним числом
 * атрибуцию Play не пересчитывает.
 */
export type PlayStoreSource =
  | 'feed-banner'
  | 'discover-banner'
  | 'chats-banner'
  | 'landing-hero'
  | 'landing-section'
  | 'landing-footer'
  | 'app-footer'
  | 'email'
  | 'discord';

/**
 * `referrer` — это ОДНО значение, внутри которого лежит целая query-строка, поэтому
 * её надо закодировать целиком. Собранная руками конкатенация ломается в обе стороны:
 * без кодирования Play обрезает всё после первого `&`, при двойном — отдаёт мусор.
 */
export const playStoreUrl = (source: PlayStoreSource, campaign = 'android-launch') => {
  const referrer = new URLSearchParams({
    utm_source: 'teamplay-web',
    utm_medium: source,
    utm_campaign: campaign,
  }).toString();

  return `https://play.google.com/store/apps/details?id=${PLAY_PACKAGE}&referrer=${encodeURIComponent(referrer)}`;
};
